import React from 'react';
import PropTypes from 'prop-types';
import {graphql} from 'react-apollo';
import Helmet from 'react-helmet-async';
import {get} from 'lodash';
import translate from '../../utils/translations';
import updateADL from '../../utils/adl';
import {ConfirmationToTIDQuery} from './ConfirmationToTIDQuery';
import {bookingConfirmationPresented, TRIPS} from '../../utils/edapUtils';
import haWrapper from '../../utils/haWrapper';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import Confirmation from '../Confirmation/Confirmation';
import './ConfirmationToTID.less';
import {
    getItem1,
    getItem2,
    getItem3,
    getItem4,
    getPaymentSplit,
} from '../../utils/analyticsDataMapping';
import {getConfirmationToTIDRedirectTimeout} from '../../utils/confirmation';
import {extendTcVars} from '../../utils/tcVarsUpdater';

export class ConfirmationToTID extends React.Component {
    static propTypes = {
        isVrbexNative: PropTypes.bool,
        reservationId: PropTypes.string,
        systemData: PropTypes.shape({}),
        translations: PropTypes.shape({}),
        unitLink: PropTypes.string,
        bookingFlow: PropTypes.string,
        tripViewId: PropTypes.string,
        tripItemId: PropTypes.string,
        tripsSandbox: PropTypes.string,
    };

    static defaultProps = {
        isVrbexNative: false,
        reservationId: '',
        translations: {},
        unitLink: '',
    };

    componentDidMount() {
        const WPFailed = this.isWeatherPromiseFailure(
            this.props?.data?.ecomPriceDetails
        );

        if (!WPFailed) {
            haWrapper.userTiming.mark('primary.action.rendered');
            updateADL('travelerdash booking confirmation');

            bookingConfirmationPresented({
                action_location: TRIPS,
                reservation_id: this.props.reservationId,
                ...this.props?.data?.bookingConfirmation?.edapAnalyticsPayload,
                item4: getItem4(
                    get(this.props, 'data.bookingConfirmation.listing')
                ),
                item3: getItem3(
                    get(this.props, 'data.bookingConfirmation.listing')
                ),
                item2: getItem2(
                    get(this.props, 'data.bookingConfirmation.listing')
                ),
                item1: getItem1(
                    get(this.props, 'data.bookingConfirmation.listing')
                ),
                paymentsplit: getPaymentSplit(
                    get(this.props, 'data.ecomPriceDetails'),
                    get(
                        this.props,
                        'data.bookingConfirmation.bookingSummary.reservationStatus'
                    )
                ),
                booking_flow: get(this.props, 'bookingFlow'),
                lodging_directory_id: get(
                    this.props,
                    'data.bookingConfirmation.listing.lodgingDirectoryId'
                ),
            });
            window.analyticsdatalayer.integratedPropertyManager = get(
                this.props,
                'data.bookingConfirmation.listing.integratedPropertyManager',
                false
            );

            const {systemData, tripViewId, tripItemId, tripsSandbox} =
                this.props;

            const timeout = getConfirmationToTIDRedirectTimeout(systemData);
            setTimeout(() => {
                if (tripsSandbox) {
                    window.location.replace(
                        `/trips/${tripViewId}/details/${tripItemId}?confirmationView=true&tripsSandbox=${tripsSandbox}`
                    );
                } else {
                    window.location.replace(
                        `/trips/${tripViewId}/details/${tripItemId}?confirmationView=true`
                    );
                }
            }, timeout);
        }
        extendTcVars({
            lodging_directory_id: get(
                this.props,
                'data.bookingConfirmation.listing.lodgingDirectoryId'
            ),
        });
    }

    isWeatherPromiseFailure(priceDetails) {
        const failedInsurtechItems = priceDetails?.failedInsurtechItems;

        return (
            Array.isArray(failedInsurtechItems) &&
            failedInsurtechItems.some(
                (item) => item.vasPaymentDetails?.type === 'WEATHER_PROMISE'
            )
        );
    }

    render() {
        const {
            isVrbexNative,
            reservationId,
            unitLink,
            bookingFlow,
            systemData,
            translations,
            path,
            isUserLoggedIn,
        } = this.props;

        const WPFailed = this.isWeatherPromiseFailure(
            this.props?.data?.ecomPriceDetails
        );

        if (!WPFailed) {
            const title = (
                <Helmet>
                    <title>
                        {translate(
                            translations,
                            'trav-dash/trav-home',
                            'nav',
                            'th.tabs.confirmation'
                        )}
                    </title>
                </Helmet>
            );

            return (
                <section className="container">
                    {title}
                    <div className="Confirmation">
                        <LoadingOverlay />
                    </div>
                </section>
            );
        }

        return (
            <Confirmation
                isUserLoggedIn={isUserLoggedIn}
                path={path}
                isVrbexNative={isVrbexNative}
                reservationId={reservationId}
                systemData={systemData}
                translations={translations}
                unitLink={unitLink}
                bookingFlow={bookingFlow}
            />
        );
    }
}

export default graphql(ConfirmationToTIDQuery, {
    options: (ownProps) => ({
        variables: {
            reservationId: ownProps.reservationId,
            unitLink: ownProps.unitLink,
        },
        errorPolicy: 'all',
    }),
})(ConfirmationToTID);
